import { useEffect, useMemo, useState } from 'react'
import { Box } from '@mui/material'
import cx from 'classnames'

import useStyles from './style'

const DoubleNumberInput = ({ label, min = 0, max = 10, value = 0, onChange = () => {} }) => {
  const [value1, setValue1] = useState(value ? value.toFixed(1).split('.')[0] : 0)
  const [value2, setValue2] = useState(value ? value.toFixed(2).split('.')[1] : 0)
  const classes = useStyles()

  const combinedValue = useMemo(() => Number(`${value1 || 0}.${value2 || 0}`), [value1, value2])

  const onBlur = (e, mainValue) => {
    if (mainValue) {
      if (Number(e.target.value) > max) {
        setValue1(max)
        setValue2(0)
      } else {
        setValue1(Number(e.target.value))
      }

      return
    }

    const isInvalid = Number(`${value1}.${e.target.value}`) > max

    if (isInvalid) {
      setValue1(max)
      setValue2(0)
    } else {
      setValue2(e.target.value > 99 ? 99 : Number(e.target.value) || 0)
    }
  }

  useEffect(() => {
    onChange(combinedValue)
  }, [combinedValue])

  return (
    <Box
      className={cx(classes.box, {
        [classes.invalid]: combinedValue > max,
      })}
    >
      <Box className={classes.label}>{label}</Box>
      <Box className={classes.body}>
        <Box>
          <input
            type="number"
            value={value1}
            min={min}
            max={max}
            onChange={(e) => setValue1(e.target.value)}
            onBlur={(e) => onBlur(e, true)}
            className={classes.input}
          />
        </Box>
        <span>.</span>
        <Box>
          <input
            type="number"
            value={value2}
            min={0}
            max={99}
            onChange={(e) => setValue2(e.target.value)}
            onBlur={(e) => onBlur(e, false)}
            className={classes.input}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default DoubleNumberInput
